var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indexNews"},[_c('router-view'),_c('footerCard',{staticClass:"footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }